import { CourseModuleDto } from "./CourseModuleDto";
import { TeacherDto } from "./TeacherDto";

export class CourseDto{
    id!:string;
    title!:string;
    description!:string;
    teacherId!:string;
    teacher!:TeacherDto;
    courseModules!:CourseModuleDto[];
    price!:number;
    isAvailable?:boolean;
    order!:number;
    isPublic?:boolean;
    thumbnailUrl?:string;
    isActive!:boolean;
    isPublished!:boolean;
}

export class CourseCreateDto{
    title!:string;
    teacherId!:string;
    description!:string;
    price!:number;
    isPublic?:boolean;
}